import React from "react";
import PropTypes from "prop-types";
import Button from "@mui/material/Button";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import Grow from "@mui/material/Grow";
import Paper from "@mui/material/Paper";
import Popper from "@mui/material/Popper";
import styles from "./DropdownMenu.module.scss";

class DropdownMenu extends React.Component {
  static openInstance = null;
  constructor(props) {
    super(props);
    this.state = { open: false };
    this.anchorEl = null;
  }

  static defaultProps = {
    btnStyle: styles["btn"],
    paperStyle: styles["menu__paper"],
    popperStyle: styles["menu"]
  };

  static propTypes = {
    anchorContent: PropTypes.func.isRequired,
    className: PropTypes.string,
    btnStyle: PropTypes.string,
    paperStyle: PropTypes.string,
    popperStyle: PropTypes.string
  };

  handleToggle = (e) => {
    e.stopPropagation();
    if (DropdownMenu.openInstance && DropdownMenu.openInstance !== this) {
      DropdownMenu.openInstance.handleClose();
    }

    this.setState((prev) => {
      const nowOpen = !prev.open;
      if (nowOpen) DropdownMenu.openInstance = this;
      else DropdownMenu.openInstance = null;
      return { open: nowOpen };
    });
  };

  handleClose = (event) => {
    // if (this.anchorEl.contains(event.target)) {
    //   return;
    // }

    if (this.state.open) {
      this.setState({ open: false });
      if (DropdownMenu.openInstance === this) {
        DropdownMenu.openInstance = null;
      }
    }
  };

  render() {
    const { btnStyle, paperStyle, popperStyle, anchorContent, className } = this.props;
    const { open } = this.state;

    return (
      <React.Fragment>
        <Button
          className={className ? className + " " + btnStyle : btnStyle}
          ref={(node) => {
            this.anchorEl = node;
          }}
          aria-owns={open ? "menu-list-grow" : undefined}
          aria-haspopup="true"
          onClick={this.handleToggle}
        >
          {anchorContent(open)}
        </Button>
        <Popper
          open={open}
          anchorEl={this.anchorEl}
          className={className ? className : popperStyle}
          transition
          disablePortal
        >
          {({ TransitionProps, placement }) => (
            <Grow
              {...TransitionProps}
              id="menu-list-grow"
              style={{
                transformOrigin: placement === "bottom" ? "center top" : "center bottom"
              }}
            >
              <Paper className={paperStyle}>
                <ClickAwayListener onClickAway={this.handleClose}>
                  {this.props.children(this.handleClose)}
                </ClickAwayListener>
              </Paper>
            </Grow>
          )}
        </Popper>
      </React.Fragment>
    );
  }
}

// DropdownMenu.propTypes = {
//   btnStyle: PropTypes.object,
//   paperStyle: PropTypes.object,
//   popperStyle: PropTypes.object,
//   children: PropTypes.node
// };
export default DropdownMenu;
